import * as Yup from 'yup';
import { StepOriginalOperatorForm } from './step-original-operator-types';

export const stepOriginalOperatorSchema = () =>
  Yup.object<StepOriginalOperatorForm>().shape({
    subjectIdentifier: Yup.string().nullable().required('Povinné pole'),
  });
